module.exports = __webpack_public_path__ + "static/media/google-play.445ecd84.png";